import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Logo } from './Logo';
import { clinic, patientLinks } from '../../data/clinic';
const careLinks = [{
  label: 'Pijnklachten',
  to: '/pijnbehandelingen'
}, {
  label: 'Behandelingen',
  to: '/behandelingen'
}, {
  label: 'Voor verwijzers',
  to: '/verwijzers'
}, {
  label: 'Over ons',
  to: '/over-ons'
}, {
  label: 'Ervaringen',
  to: '/ervaringen'
}, {
  label: 'Vacatures',
  to: '/vacatures'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Footer() {
  return <footer className="bg-ink text-white" data-id="element-161" data-mp="3n3k9u6dm4nqe">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-12 lg:px-8 lg:py-20" data-id="element-162" data-mp="3n4lun2kfkolb">
        <div className="lg:col-span-4" data-id="element-163" data-mp="3j30g7cs90290">
          <div className="inline-flex rounded-2xl bg-white px-4 py-3" data-id="element-164" data-mp="3j05sncdxu1bd">
            <Logo className="h-10" data-id="element-165" data-mp="3e2coeow73hdq" />
          </div>
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-white/70" data-id="element-166" data-mp="3942uehm7imtp">
            Onafhankelijk specialistisch pijnbehandelcentrum in Velsen-Noord. Behandeling door anesthesioloog-pijnspecialisten
            en (pijn)verpleegkundigen.
          </p>
          <ul className="mt-6 flex gap-5" data-id="element-167" data-mp="2p54kyh2im169">
            {clinic.socials.map(s => <li key={s.label} data-id="element-168" data-mp="2bdzqruhx213b">
                <a href={s.href} target="_blank" rel="noreferrer" className="text-sm font-medium text-cyan hover:text-white" data-id="element-169" data-mp="2gbj3gpyyu5t5">
                  {s.label}
                </a>
              </li>)}
          </ul>
        </div>

        <nav aria-label="Zorg" className="lg:col-span-2" data-id="element-170" data-mp="382z07cu8l8x3">
          <h2 className="font-display text-base font-semibold" data-id="element-171" data-mp="380crvaziupdt">Zorg</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-172" data-mp="2u2o7035gfi8r">
            {careLinks.map(item => <li key={item.to} data-id="element-173" data-mp="2z0pncgbhx3gj">
                <Link to={item.to} className="text-[15px] text-white/70 hover:text-white" data-id="element-174" data-mp="2z3u0i36xv9jc">
                  {item.label}
                </Link>
              </li>)}
            <li data-id="element-175" data-mp="1no5dxcxlkcj2">
              <a href={clinic.longCovidUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[15px] text-white/70 hover:text-white" data-id="element-176" data-mp="1nkrd494l0bdq">
                Long COVID
                <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-177" data-mp="zl8swx1wlcz8" />
              </a>
            </li>
          </ul>
        </nav>

        <nav aria-label="Voor patiënten" className="lg:col-span-3" data-id="element-178" data-mp="ptun67jczgxn">
          <h2 className="font-display text-base font-semibold" data-id="element-179" data-mp="pri75zx5vgn8">Voor patiënten</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-180" data-mp="kvjei04svch0">
            {patientLinks.map(item => <li key={item.label} data-id="element-181" data-mp="ftlp0o5t3lfm">
                {item.external ? <a href={item.to} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[15px] text-white/70 hover:text-white" data-id="element-182" data-mp="bul6z7v5kmto">
                    {item.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-183" data-mp="267ujz9mwqqgo" />
                  </a> : <Link to={item.to} className="text-[15px] text-white/70 hover:text-white" data-id="element-184" data-mp="219syyj5x8h2k">
                    {item.label}
                  </Link>}
              </li>)}
          </ul>
        </nav>

        <div className="lg:col-span-3" data-id="element-185" data-mp="2dp0xi27ky1t3">
          <h2 className="font-display text-base font-semibold" data-id="element-186" data-mp="2ihk7kp726et5">Bezoek & contact</h2>
          <address className="mt-4 space-y-3 text-[15px] not-italic text-white/70" data-id="element-187" data-mp="2ngnd0aqyan1n">
            <p data-id="element-188" data-mp="1pt4uw9beg8kz">
              {clinic.street}
              <br data-id="element-189" data-mp="1pu6g36m4qbgf" />
              {clinic.postalCode} {clinic.city}
            </p>
            <p data-id="element-190" data-mp="1urg5im9iqn49">
              <a href={clinic.phoneHref} className="font-semibold text-cyan hover:text-white" data-id="element-191" data-mp="1ut0zoarx841l">
                {clinic.phone}
              </a>
              <br data-id="element-192" data-mp="1ztp01n21hx8h" />
              <a href={`mailto:${clinic.email}`} className="break-all hover:text-white" data-id="element-193" data-mp="23so4z7nrttzx">
                {clinic.email}
              </a>
            </p>
            <p data-id="element-194" data-mp="3b67xwz6nzudk">{clinic.hours}</p>
          </address>
        </div>
      </div>
      <div className="border-t border-white/10" data-id="element-195" data-mp="3f71j3ksq2v2r">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-6 text-sm text-white/60 sm:flex-row sm:justify-between lg:px-8" data-id="element-196" data-mp="3f9xhtbce9ns9">
          <p data-id="element-197" data-mp="38smd2lpxkeu5">© 2026 Excellent Care Clinics</p>
          <div className="flex gap-6" data-id="element-198" data-mp="38txfah3q9ej5">
            <Link to="/klachteninformatie" className="hover:text-white" data-id="element-199" data-mp="3npmtht2o8ndb">
              Klachteninformatie
            </Link>
            <a href={clinic.termsPdf} target="_blank" rel="noreferrer" className="hover:text-white" data-id="element-200" data-mp="3ip7gj2maxhvv">
              Algemene voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>;
}